// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/analytics/analytics_service.proto (package api.v1.analytics, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_v1_common_common_types } from "../common/common_types_pb";
import type { Pagination, PaginationRequest } from "../common/pagination_pb";
import { file_v1_common_pagination } from "../common/pagination_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/analytics/analytics_service.proto.
 */
export const file_v1_analytics_analytics_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_empty, file_google_protobuf_timestamp, file_v1_common_common_types, file_v1_common_pagination]);

/**
 * DeviceContext provides information about the device from which the interaction occurred
 *
 * @generated from message api.v1.analytics.DeviceContext
 */
export type DeviceContext = Message<"api.v1.analytics.DeviceContext"> & {
  /**
   * Unique identifier for the device
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * Type of device (mobile, desktop, tablet)
   *
   * @generated from field: string device_type = 2;
   */
  deviceType: string;

  /**
   * Operating system name (iOS, Android, Windows, macOS)
   *
   * @generated from field: string os_name = 3;
   */
  osName: string;

  /**
   * Operating system version
   *
   * @generated from field: string os_version = 4;
   */
  osVersion: string;

  /**
   * Browser name if applicable
   *
   * @generated from field: string browser_name = 5;
   */
  browserName: string;

  /**
   * Browser version if applicable
   *
   * @generated from field: string browser_version = 6;
   */
  browserVersion: string;

  /**
   * App version if interaction is from a mobile app
   *
   * @generated from field: string app_version = 7;
   */
  appVersion: string;

  /**
   * Full user agent string
   *
   * @generated from field: string user_agent = 8;
   */
  userAgent: string;

  /**
   * Unique identifier for the user session
   *
   * @generated from field: string session_id = 9;
   */
  sessionId: string;
};

/**
 * Describes the message api.v1.analytics.DeviceContext.
 * Use `create(DeviceContextSchema)` to create a new message.
 */
export const DeviceContextSchema: GenMessage<DeviceContext> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 0);

/**
 * LocationContext provides geographic information for the interaction
 *
 * @generated from message api.v1.analytics.LocationContext
 */
export type LocationContext = Message<"api.v1.analytics.LocationContext"> & {
  /**
   * Latitude coordinate if available
   *
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * Longitude coordinate if available
   *
   * @generated from field: double longitude = 2;
   */
  longitude: number;

  /**
   * Country code
   *
   * @generated from field: string country = 3;
   */
  country: string;

  /**
   * Region or state
   *
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * City
   *
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * Postal code
   *
   * @generated from field: string postal_code = 6;
   */
  postalCode: string;

  /**
   * Timezone identifier
   *
   * @generated from field: string timezone = 7;
   */
  timezone: string;

  /**
   * IP address (for server-side use only)
   *
   * @generated from field: string ip_address = 8;
   */
  ipAddress: string;
};

/**
 * Describes the message api.v1.analytics.LocationContext.
 * Use `create(LocationContextSchema)` to create a new message.
 */
export const LocationContextSchema: GenMessage<LocationContext> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 1);

/**
 * Interaction represents a single interaction with an entity
 *
 * @generated from message api.v1.analytics.Interaction
 */
export type Interaction = Message<"api.v1.analytics.Interaction"> & {
  /**
   * Unique identifier for this interaction
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Type of entity (event, product, service, etc.)
   *
   * @generated from field: api.v1.analytics.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * ID of the entity
   *
   * @generated from field: optional string entity_id = 3;
   */
  entityId?: string;

  /**
   * ID of the user (if authenticated)
   *
   * @generated from field: optional string user_id = 4;
   */
  userId?: string;

  /**
   * Anonymous ID for tracking non-authenticated users
   *
   * @generated from field: string anonymous_id = 5;
   */
  anonymousId: string;

  /**
   * Type of interaction
   *
   * @generated from field: api.v1.analytics.InteractionType interaction_type = 6;
   */
  interactionType: InteractionType;

  /**
   * Information about the device
   *
   * @generated from field: api.v1.analytics.DeviceContext device_context = 8;
   */
  deviceContext?: DeviceContext;

  /**
   * Geographic information
   *
   * @generated from field: api.v1.analytics.LocationContext location_context = 9;
   */
  locationContext?: LocationContext;

  /**
   * Additional properties relevant to the interaction
   *
   * @generated from field: map<string, string> properties = 10;
   */
  properties: { [key: string]: string };

  /**
   * Unique identifier for the user session
   *
   * @generated from field: string session_id = 11;
   */
  sessionId: string;

  /**
   * Referring URL or source
   *
   * @generated from field: optional string referrer = 12;
   */
  referrer?: string;

  /**
   * Client-side timestamp when the event was generated
   *
   * @generated from field: google.protobuf.Timestamp client_timestamp = 13;
   */
  clientTimestamp?: Timestamp;

  /**
   * ID for batch processing, if applicable
   *
   * @generated from field: string correlation_id = 14;
   */
  correlationId: string;
};

/**
 * Describes the message api.v1.analytics.Interaction.
 * Use `create(InteractionSchema)` to create a new message.
 */
export const InteractionSchema: GenMessage<Interaction> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 2);

/**
 * TrackInteractionRequest is used to track a single entity interaction
 *
 * @generated from message api.v1.analytics.TrackInteractionRequest
 */
export type TrackInteractionRequest = Message<"api.v1.analytics.TrackInteractionRequest"> & {
  /**
   * @generated from field: api.v1.analytics.Interaction interaction = 1;
   */
  interaction?: Interaction;
};

/**
 * Describes the message api.v1.analytics.TrackInteractionRequest.
 * Use `create(TrackInteractionRequestSchema)` to create a new message.
 */
export const TrackInteractionRequestSchema: GenMessage<TrackInteractionRequest> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 3);

/**
 * TrackInteractionBatchRequest is used to track multiple entity interactions at once
 *
 * @generated from message api.v1.analytics.TrackInteractionBatchRequest
 */
export type TrackInteractionBatchRequest = Message<"api.v1.analytics.TrackInteractionBatchRequest"> & {
  /**
   * @generated from field: repeated api.v1.analytics.Interaction interactions = 1;
   */
  interactions: Interaction[];
};

/**
 * Describes the message api.v1.analytics.TrackInteractionBatchRequest.
 * Use `create(TrackInteractionBatchRequestSchema)` to create a new message.
 */
export const TrackInteractionBatchRequestSchema: GenMessage<TrackInteractionBatchRequest> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 4);

/**
 * GetStatsRequest is used to request analytics for a specific entity
 *
 * @generated from message api.v1.analytics.GetStatsRequest
 */
export type GetStatsRequest = Message<"api.v1.analytics.GetStatsRequest"> & {
  /**
   * Type of entity
   *
   * @generated from field: api.v1.analytics.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * ID of the entity
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * Start of stats period
   *
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp;

  /**
   * End of stats period
   *
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp;

  /**
   * Include device stats
   *
   * @generated from field: bool include_device_breakdown = 5;
   */
  includeDeviceBreakdown: boolean;

  /**
   * Include location stats
   *
   * @generated from field: bool include_location_breakdown = 6;
   */
  includeLocationBreakdown: boolean;

  /**
   * Include referrer stats
   *
   * @generated from field: bool include_referrer_breakdown = 7;
   */
  includeReferrerBreakdown: boolean;
};

/**
 * Describes the message api.v1.analytics.GetStatsRequest.
 * Use `create(GetStatsRequestSchema)` to create a new message.
 */
export const GetStatsRequestSchema: GenMessage<GetStatsRequest> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 5);

/**
 * EntityStats contains analytics data for an entity
 *
 * @generated from message api.v1.analytics.EntityStats
 */
export type EntityStats = Message<"api.v1.analytics.EntityStats"> & {
  /**
   * Type of entity
   *
   * @generated from field: api.v1.analytics.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * ID of the entity
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * Total views
   *
   * @generated from field: int32 view_count = 3;
   */
  viewCount: number;

  /**
   * Detail page views
   *
   * @generated from field: int32 detail_view_count = 4;
   */
  detailViewCount: number;

  /**
   * List view impressions
   *
   * @generated from field: int32 list_view_count = 5;
   */
  listViewCount: number;

  /**
   * Number of saves
   *
   * @generated from field: int32 save_count = 6;
   */
  saveCount: number;

  /**
   * Number of shares
   *
   * @generated from field: int32 share_count = 7;
   */
  shareCount: number;

  /**
   * Number of registrations/purchases
   *
   * @generated from field: int32 registration_count = 8;
   */
  registrationCount: number;

  /**
   * Number of RSVPs (primarily for events)
   *
   * @generated from field: int32 rsvp_count = 9;
   */
  rsvpCount: number;

  /**
   * Number of check-ins (primarily for events)
   *
   * @generated from field: int32 checkin_count = 10;
   */
  checkinCount: number;

  /**
   * Conversion rate (views to registrations)
   *
   * @generated from field: float conversion_rate = 11;
   */
  conversionRate: number;

  /**
   * Start of the stats period
   *
   * @generated from field: google.protobuf.Timestamp start_date = 15;
   */
  startDate?: Timestamp;

  /**
   * End of the stats period
   *
   * @generated from field: google.protobuf.Timestamp end_date = 16;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message api.v1.analytics.EntityStats.
 * Use `create(EntityStatsSchema)` to create a new message.
 */
export const EntityStatsSchema: GenMessage<EntityStats> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 6);

/**
 * ListInteractionsRequest is used to request a list of interactions for an entity
 *
 * @generated from message api.v1.analytics.ListInteractionsRequest
 */
export type ListInteractionsRequest = Message<"api.v1.analytics.ListInteractionsRequest"> & {
  /**
   * @generated from field: api.v1.analytics.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: repeated api.v1.analytics.InteractionType interaction_types = 5;
   */
  interactionTypes: InteractionType[];

  /**
   * @generated from field: api.v1.common.PaginationRequest pagination = 6;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message api.v1.analytics.ListInteractionsRequest.
 * Use `create(ListInteractionsRequestSchema)` to create a new message.
 */
export const ListInteractionsRequestSchema: GenMessage<ListInteractionsRequest> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 7);

/**
 * ListInteractionsResponse contains a paginated list of entity interactions
 *
 * @generated from message api.v1.analytics.ListInteractionsResponse
 */
export type ListInteractionsResponse = Message<"api.v1.analytics.ListInteractionsResponse"> & {
  /**
   * @generated from field: repeated api.v1.analytics.Interaction interactions = 1;
   */
  interactions: Interaction[];

  /**
   * @generated from field: api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message api.v1.analytics.ListInteractionsResponse.
 * Use `create(ListInteractionsResponseSchema)` to create a new message.
 */
export const ListInteractionsResponseSchema: GenMessage<ListInteractionsResponse> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 8);

/**
 * StreamConfiguration contains configuration for the analytics stream
 *
 * @generated from message api.v1.analytics.StreamConfiguration
 */
export type StreamConfiguration = Message<"api.v1.analytics.StreamConfiguration"> & {
  /**
   * Unique identifier for the stream
   *
   * @generated from field: string stream_id = 1;
   */
  streamId: string;

  /**
   * URL of the MQTT broker
   *
   * @generated from field: string broker_url = 2;
   */
  brokerUrl: string;

  /**
   * Client ID for MQTT connection
   *
   * @generated from field: string client_id = 3;
   */
  clientId: string;

  /**
   * Quality of Service level (0, 1, or 2)
   *
   * @generated from field: int32 qos = 4;
   */
  qos: number;

  /**
   * Number of events to batch before sending
   *
   * @generated from field: int32 batch_size = 5;
   */
  batchSize: number;

  /**
   * Time between forced flushes
   *
   * @generated from field: int32 flush_interval_seconds = 6;
   */
  flushIntervalSeconds: number;

  /**
   * Path for local persistence
   *
   * @generated from field: string persistence_path = 7;
   */
  persistencePath: string;

  /**
   * Maximum number of retry attempts
   *
   * @generated from field: int32 max_retry_attempts = 8;
   */
  maxRetryAttempts: number;

  /**
   * Initial delay between retries in milliseconds
   *
   * @generated from field: int32 retry_delay_ms = 9;
   */
  retryDelayMs: number;

  /**
   * Whether to enable local persistence
   *
   * @generated from field: bool enable_local_persistence = 10;
   */
  enableLocalPersistence: boolean;

  /**
   * List of topic prefixes to use
   *
   * @generated from field: repeated string topic_prefixes = 11;
   */
  topicPrefixes: string[];
};

/**
 * Describes the message api.v1.analytics.StreamConfiguration.
 * Use `create(StreamConfigurationSchema)` to create a new message.
 */
export const StreamConfigurationSchema: GenMessage<StreamConfiguration> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 9);

/**
 * ProcessStashRequest is used to process QStash webhook messages
 *
 * @generated from message api.v1.analytics.ProcessStashRequest
 */
export type ProcessStashRequest = Message<"api.v1.analytics.ProcessStashRequest"> & {
  /**
   * Raw message body from QStash webhook
   *
   * @generated from field: bytes message = 1;
   */
  message: Uint8Array;

  /**
   * QStash headers for verification (includes Upstash-Signature, My-Header, etc.)
   *
   * @generated from field: map<string, string> headers = 2;
   */
  headers: { [key: string]: string };

  /**
   * Optional topic from QStash URL parameters
   *
   * @generated from field: optional string topic = 3;
   */
  topic?: string;

  /**
   * Optional correlation ID for tracing (can be extracted from headers if not provided)
   *
   * @generated from field: optional string correlation_id = 4;
   */
  correlationId?: string;
};

/**
 * Describes the message api.v1.analytics.ProcessStashRequest.
 * Use `create(ProcessStashRequestSchema)` to create a new message.
 */
export const ProcessStashRequestSchema: GenMessage<ProcessStashRequest> = /*@__PURE__*/
  messageDesc(file_v1_analytics_analytics_service, 10);

/**
 * EntityType defines the different types of entities that can be tracked
 *
 * @generated from enum api.v1.analytics.EntityType
 */
export enum EntityType {
  /**
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_EVENT = 1;
   */
  EVENT = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_PRODUCT = 2;
   */
  PRODUCT = 2,

  /**
   * @generated from enum value: ENTITY_TYPE_SERVICE = 3;
   */
  SERVICE = 3,

  /**
   * @generated from enum value: ENTITY_TYPE_ORG = 4;
   */
  ORG = 4,

  /**
   * @generated from enum value: ENTITY_TYPE_REVIEW = 5;
   */
  REVIEW = 5,
}

/**
 * Describes the enum api.v1.analytics.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_v1_analytics_analytics_service, 0);

/**
 * InteractionType defines the types of interactions that can occur with entities
 *
 * @generated from enum api.v1.analytics.InteractionType
 */
export enum InteractionType {
  /**
   * @generated from enum value: INTERACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * View-related interactions
   *
   * Viewed in a list
   *
   * @generated from enum value: INTERACTION_TYPE_VIEW_LIST = 1;
   */
  VIEW_LIST = 1,

  /**
   * Viewed details page
   *
   * @generated from enum value: INTERACTION_TYPE_VIEW_DETAIL = 2;
   */
  VIEW_DETAIL = 2,

  /**
   * Viewed related items
   *
   * @generated from enum value: INTERACTION_TYPE_VIEW_RELATED = 3;
   */
  VIEW_RELATED = 3,

  /**
   * Engagement interactions
   *
   * Saved to collection
   *
   * @generated from enum value: INTERACTION_TYPE_SAVE = 10;
   */
  SAVE = 10,

  /**
   * Removed from saved collection
   *
   * @generated from enum value: INTERACTION_TYPE_UNSAVE = 11;
   */
  UNSAVE = 11,

  /**
   * Shared
   *
   * @generated from enum value: INTERACTION_TYPE_SHARE = 12;
   */
  SHARE = 12,

  /**
   * Registered for or purchased
   *
   * @generated from enum value: INTERACTION_TYPE_REGISTER = 13;
   */
  REGISTER = 13,

  /**
   * Followed entity
   *
   * @generated from enum value: INTERACTION_TYPE_FOLLOW = 14;
   */
  FOLLOW = 14,

  /**
   * Attendance/participation interactions
   *
   * RSVPed
   *
   * @generated from enum value: INTERACTION_TYPE_RSVP = 20;
   */
  RSVP = 20,

  /**
   * Checked in
   *
   * @generated from enum value: INTERACTION_TYPE_CHECK_IN = 21;
   */
  CHECK_IN = 21,

  /**
   * Canceled participation
   *
   * @generated from enum value: INTERACTION_TYPE_CANCEL = 22;
   */
  CANCEL = 22,

  /**
   * Creator interactions
   *
   * Created entity
   *
   * @generated from enum value: INTERACTION_TYPE_CREATE = 30;
   */
  CREATE = 30,

  /**
   * Updated entity
   *
   * @generated from enum value: INTERACTION_TYPE_UPDATE = 31;
   */
  UPDATE = 31,

  /**
   * Deleted entity
   *
   * @generated from enum value: INTERACTION_TYPE_DELETE = 32;
   */
  DELETE = 32,

  /**
   * Rescheduled entity
   *
   * @generated from enum value: INTERACTION_TYPE_RESCHEDULE = 33;
   */
  RESCHEDULE = 33,

  /**
   * Notification interactions
   *
   * Notification sent
   *
   * @generated from enum value: INTERACTION_TYPE_NOTIFICATION_SEND = 40;
   */
  NOTIFICATION_SEND = 40,

  /**
   * Notification opened
   *
   * @generated from enum value: INTERACTION_TYPE_NOTIFICATION_OPEN = 41;
   */
  NOTIFICATION_OPEN = 41,

  /**
   * Notification clicked
   *
   * @generated from enum value: INTERACTION_TYPE_NOTIFICATION_CLICK = 42;
   */
  NOTIFICATION_CLICK = 42,

  /**
   * Review interactions
   *
   * Submitted review
   *
   * @generated from enum value: INTERACTION_TYPE_REVIEW_SUBMIT = 50;
   */
  REVIEW_SUBMIT = 50,

  /**
   * Updated review
   *
   * @generated from enum value: INTERACTION_TYPE_REVIEW_UPDATE = 51;
   */
  REVIEW_UPDATE = 51,

  /**
   * Deleted review
   *
   * @generated from enum value: INTERACTION_TYPE_REVIEW_DELETE = 52;
   */
  REVIEW_DELETE = 52,

  /**
   * Replied to review
   *
   * @generated from enum value: INTERACTION_TYPE_REVIEW_REPLY = 53;
   */
  REVIEW_REPLY = 53,

  /**
   * Marked review as helpful
   *
   * @generated from enum value: INTERACTION_TYPE_REVIEW_HELPFUL = 54;
   */
  REVIEW_HELPFUL = 54,

  /**
   * Form interactions
   *
   * Form started
   *
   * @generated from enum value: INTERACTION_TYPE_FORM_START = 60;
   */
  FORM_START = 60,

  /**
   * Form submitted
   *
   * @generated from enum value: INTERACTION_TYPE_FORM_SUBMIT = 61;
   */
  FORM_SUBMIT = 61,

  /**
   * Form abandoned
   *
   * @generated from enum value: INTERACTION_TYPE_FORM_ABANDON = 62;
   */
  FORM_ABANDON = 62,

  /**
   * Form field interaction
   *
   * @generated from enum value: INTERACTION_TYPE_FORM_FIELD_INTERACTION = 63;
   */
  FORM_FIELD_INTERACTION = 63,

  /**
   * Form validation error
   *
   * @generated from enum value: INTERACTION_TYPE_FORM_VALIDATION_ERROR = 64;
   */
  FORM_VALIDATION_ERROR = 64,

  /**
   * Form step changed
   *
   * @generated from enum value: INTERACTION_TYPE_FORM_STEP_CHANGE = 65;
   */
  FORM_STEP_CHANGE = 65,

  /**
   * Search interactions
   *
   * Searched for entity
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH = 70;
   */
  SEARCH = 70,

  /**
   * Viewed search results
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_RESULTS = 71;
   */
  SEARCH_RESULTS = 71,

  /**
   * Filtered search results
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_FILTER = 72;
   */
  SEARCH_FILTER = 72,

  /**
   * Sorted search results
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_SORT = 73;
   */
  SEARCH_SORT = 73,

  /**
   * Viewed search results in list or map
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_VIEW_MODE = 74;
   */
  SEARCH_VIEW_MODE = 74,

  /**
   * Loaded more search results
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_LOAD_MORE = 75;
   */
  SEARCH_LOAD_MORE = 75,

  /**
   * Queried search results
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_QUERY = 76;
   */
  SEARCH_QUERY = 76,

  /**
   * Changed search location
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_LOCATION = 77;
   */
  SEARCH_LOCATION = 77,

  /**
   * Changed search date
   *
   * @generated from enum value: INTERACTION_TYPE_SEARCH_DATE = 78;
   */
  SEARCH_DATE = 78,

  /**
   * External ticketing interactions
   *
   * Clicked external ticket button
   *
   * @generated from enum value: INTERACTION_TYPE_EXTERNAL_TICKET_CLICK = 80;
   */
  EXTERNAL_TICKET_CLICK = 80,

  /**
   * Confirmed exit to external ticketing site
   *
   * @generated from enum value: INTERACTION_TYPE_EXTERNAL_TICKET_EXIT = 81;
   */
  EXTERNAL_TICKET_EXIT = 81,
}

/**
 * Describes the enum api.v1.analytics.InteractionType.
 */
export const InteractionTypeSchema: GenEnum<InteractionType> = /*@__PURE__*/
  enumDesc(file_v1_analytics_analytics_service, 1);

/**
 * AnalyticsService provides methods for tracking and analyzing entity interactions
 *
 * @generated from service api.v1.analytics.AnalyticsService
 */
export const AnalyticsService: GenService<{
  /**
   * TrackBatch records entity interactions in a single request
   * For single interactions, just include one item in the interactions array
   *
   * @generated from rpc api.v1.analytics.AnalyticsService.TrackBatch
   */
  trackBatch: {
    methodKind: "unary";
    input: typeof TrackInteractionBatchRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetStats retrieves analytics for a specific entity
   *
   * @generated from rpc api.v1.analytics.AnalyticsService.GetStats
   */
  getStats: {
    methodKind: "unary";
    input: typeof GetStatsRequestSchema;
    output: typeof EntityStatsSchema;
  },
  /**
   * ListInteractions retrieves a paginated list of interactions for an entity
   *
   * @generated from rpc api.v1.analytics.AnalyticsService.ListInteractions
   */
  listInteractions: {
    methodKind: "unary";
    input: typeof ListInteractionsRequestSchema;
    output: typeof ListInteractionsResponseSchema;
  },
  /**
   * ProcessStash processes QStash webhook messages for analytics
   *
   * @generated from rpc api.v1.analytics.AnalyticsService.ProcessStash
   */
  processStash: {
    methodKind: "unary";
    input: typeof ProcessStashRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_analytics_analytics_service, 0);

